<!--
    Desarrollado por: Actualizado por Ing. Wuilmer garcia
    // Fecha: 2022/01/11
    // Modificado por: Wuilmer Garcia
    // Fecha de ultima Modificacion:  2022/01/11 
    // Causa: Actualizacion y mejora de codigo
    Historial de Modificaciones
    // Fecha Modificación: 
    // Modificación: Creación del componente
    /////////////////////////////////////////////////
-->

<template>
    <div>
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>

        <v-card v-if="temas">

            <!-- titulo y boton crear -->
            <v-row class="">
                <v-col class="d-flex justify-space-between">

                    <!-----seccion  de filtros --->
                    <v-row class="pl-2 py-0">
                        <v-col cols="12" sm="6" md="4" lg class="py-0">
                            <v-select v-model="listPais" :items="api_mant_pais"
                            label="País" item-value="id" item-text="nombre_pais" 
                            @change="filtroPais(listPais)">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" lg class="py-0">
                            <v-select  v-model="listNivel" :items="api_mant_nivel"
                            label="Nivel" item-value="id" item-text="desc_nivel"
                            @change="filtroNivel(listNivel)" :disabled="disabledNivel">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" lg class="py-0">
                            <v-select v-model="listGrado" :items="api_mant_grado"
                            label="Grado" item-value="id" item-text="desc_grado"
                            @change="filtroGrados(listGrado)"  :disabled="disabledGrado">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" lg class="py-0">
                            <v-select v-model="listArea" :items="api_mant_area"
                            label="Area" item-value="id" item-text="desc_area"
                            @change="filtroArea(listArea)" :disabled="disabledArea">
                            </v-select>
                        </v-col>

                        <v-col cols="12" sm="6" md="4" lg class="py-0">
                            <v-select v-model="listCurso" :items="api_mant_curso"
                            label="Curso:" item-value="id" item-text="desc_curso"
                            @change="filtroCursos(listCurso)" :disabled="disabledCurso">
                            </v-select>
                        </v-col>
                    </v-row>

                    <v-btn class="btn_block_style2" dark  @click="aggTema">Crear Unidad</v-btn>

                </v-col>
            </v-row> 





            <v-col class="d-flex justify-end pt-0">
                <v-col class="pt-0 pr-0" cols="4">
                    <v-text-field label="Buscar" v-model="search" append-icon="fa-search" single-line hide-details ></v-text-field>
                </v-col>
            </v-col>

            <v-data-table :headers="headers_tema" :items="vis_tema" :search="search" :sort-desc="[false]" class="elevation-1 black--text" fixed-header >

                <!---- nuevas acciones de cuaderno de trabajo -->  
                <template v-slot:[`item.cuaderno`]="{ item }" v-if="verCuadernoTrabajo">  
                    
                    <v-btn v-if="item.cuaderno_trabajo==='' || item.cuaderno_trabajo===null" class="mx-2 btn_otro" fab dark x-small title="cuaderno de actividades" @click="addCuaderno(item)">
                        <v-icon>fa-file-upload</v-icon>
                    </v-btn>
                    
                    
                    <v-menu v-else absolute offset-y style="width:380px">
                        <template v-slot:activator="{ on }">

                            <v-row justify="space-around" v-on="on">
                                <v-btn class="mx-2" fab dark x-small color="primary">
                                    <v-icon small >fas fa-book-reader</v-icon>
                                </v-btn>                      
                            </v-row>
                        </template>
                        
                        <v-card class="card-icon">
                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <div class="template-button">
                                        <p class="mr-2">Eliminar</p>
                                        <v-btn v-on="on" class="error ml-5 mb-2" fab x-small @click="deleteCuaderno(item)"  >
                                            <v-icon>fas fa-trash</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <span style="text-transform:uppercase;">ELIMINAR </span>
                            </v-tooltip>

                            <v-tooltip bottom color="#1b1b1b">
                                <template v-slot:activator="{ on }">
                                    <div class="template-button">
                                        <p>Descargar</p>
                                        <v-btn v-on="on" class="primary  ml-5 mb-2 " fab x-small dark >
                                            <a :href="ruta_api+'archivo/obtenerarchivo/'+item.cuaderno_trabajo" target="_blank"> <v-icon color="white">fas fa-file-word</v-icon></a>
                                        </v-btn>
                                    </div>
                                </template>
                                <span>DESCARGAR</span>
                            </v-tooltip>
                        </v-card>
                    </v-menu>
                </template>


                <template v-slot:[`item.action_crear_clase`]="{ item }">
                    <v-btn class="btn_block_style2" dark  @click="vistaClase(item)">Ver Temas</v-btn>
                </template>


                <template v-slot:[`item.action_editar`]="{ item }">
                    <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="btn_editar px-0 mx-0" fab x-small @click="editTema(item)">
                                <v-icon>fa-pencil-alt</v-icon>
                            </v-btn>
                        </template>
                        <span>EDITAR UNIDAD</span>
                    </v-tooltip>
                </template>


                <template v-slot:[`item.action_borrar`]="{ item }">
                    <v-tooltip bottom color="#1b1b1b">
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="btn_eliminar px-0 mx-0" fab x-small @click="showConfirmDeleteUnidad(item)">
                                <v-icon>fa-trash-alt</v-icon>
                            </v-btn>
                        </template>
                        <span>BORRAR UNIDAD</span>
                    </v-tooltip>
                </template>

            </v-data-table>         
        </v-card>


  

        <!-- /////////////////////////componente para injecccion ////////////////////-->
        <component :is="componentClase"
            :contenidos='api_contenido'
            :parametros="parametroConfig"
            :contenido='micontenido'
            :pregunta='lapregunta'
            :diapositiva="prueba"
            :elTema='datosTema'
            :dataSet='arrayGeneral'
            :miscontenidos='api_list_contenidos'
            :diapositivas='api_contenidos'
            @volverAtras='regresar'
            @actualizarClass='actualizarClase'
            @iraLista='volverClasesLista'
            @cargar-contenido='getAllContenidos'
            @aggDiapositiva='abrirSelector'
            @editar-contenido='editarContenido'
            @Atras='volverEditar'
            @editar-pregunta='editarPregunta'
            @actualizar-items='actualizarListaContenidos'           
            @irClases='injectarComponente'
            @mostrar-mensaje="mostrarMensaje">
        </component>   
        <!--//////////////////////////////////////////////////////////////////////////-->

        
        <!-----selector de tipo de diapositiva -->
        <v-row v-if="selectorColumna">
            <SelectorDiapositiva
            @cargarPlantilla="validarColumna"
            @irAtras='volverTemplate'
            ></SelectorDiapositiva>   
        </v-row>
        <!----------------------------------------->


        <!---- injeccion de tipo de Diapositiva -->
      
        <component :is="componenteTipoDiapositiva"
                   :parametros="parametroConfig"
                    @irAtras='volverSeleccion'
                    @actualizarLista='actualizarDiapositivaCreador'
                    @actulizarData='actulizarData2'
                    :dataSet='arrayGeneral'>
        </component>
                
        

        <!----------  SECCION DE MODALES   -------->
        <!-- modal -->
        <v-form ref="formTema" lazy-validation>
            <v-dialog v-model="dialog" persistent scrollable max-width="800px">
                <v-card>
                    <v-card-title class="btn_otro">
                        <v-row class="d-flex justify-space-between py-0">
                            {{ titleModalTema }}
                            <v-btn fab dark x-small class="btn_style3"  @click="closeModalTema"><v-icon dark>fa-times</v-icon></v-btn>
                        </v-row>
                    </v-card-title>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-alert type="error" v-if="errorTema" class="mt-2">{{menssageError}}</v-alert>

                        <v-row>
                            <v-col cols="12" sm="12" md="6" class="py-0">
                                <v-select v-model="editedItem.id_pais" :items="listTemaPais"
                                    label="País" item-value="id" item-text="nombre_pais" 
                                    @change="GetTemaNivelGrado(editedItem.id_pais)" :disabled="disabledTemaPais"  :rules="[rul.selectReq]">
                                </v-select>
                            </v-col> 

                            
                            <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-select v-model="editedItem.id_grado" :items="listTemaGrado"
                                        label="Grado" item-value="id" item-text="grado_nivel"   
                                        @change="GetTemaArea(editedItem.id_grado)" :disabled="disabledTemaGrado" :rules="[rul.selectReq]">
                                    </v-select>
                                </v-col>


                                <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-select v-model="editedItem.id_area" :items="listTemaArea"
                                        label="Área" item-value="id" item-text="desc_area" 
                                        @change="GetTemaCurso(editedItem.id_area)" :disabled="disabledTemaArea" :rules="[rul.selectReq]">
                                    </v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-select v-model="editedItem.id_curso" :items="listTemaCurso"
                                        label="Curso" item-value="id" item-text="desc_curso" 
                                        :disabled="disabledTemaCurso" :rules="[rul.selectReq]">
                                    </v-select>
                                </v-col>

                                <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-text-field v-model="editedItem.nombre_tema" label="Unidad" :rules="[rul.required]"></v-text-field>
                                </v-col>
                                
                                <v-col cols="12" sm="12" md="6" class="py-0">
                                    <v-text-field v-model="editedItem.orden" label="Orden" type="number" min="0" @keypress="soloNumeros($event)"></v-text-field>
                                </v-col>
                                
                                <!--
                                <pre>Datos Form:{{this.editedItem}}</pre>
                                -->
                        </v-row>
                      
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn class="btn_block_style2"   @click="updateTema(editedItem.id)" v-if="editar" :disabled="this.guardando">Guardar Cambios</v-btn>
                        <v-btn class="btn_block_style2"   @click="addTema" v-if="agregar" :disabled="this.guardando" >Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-form>
        <!--------------------------- -->



       
        <!-- confim para eliminar unidad -->
        <Confirm
            title="Desea eliminar la Unidad?"
            :active="confirmDeleteUnidad"
            @aceptar="deleteTema"
            @cancelar="cerrarConfirmDeleteUnidad"
        />


    </div>
</template>


<script>
    import axios, {API_URL} from "@/helpers/axios";
    import {mapMutations} from 'vuex';
    import ComponenteClases from './componentes/clasesComponent.vue'; 
    import componenteListaDiapositiva from './componentes/listaDispositivas.vue';
    import SelectorDiapositiva from './componentes/selectorDiapositivas.vue';
    import visorContenido from './componentes/visorContenido';
    import  Confirm from '../../../components/confirm'
    // import MiniaturasDiapositivas from './componentes/miniaturasDispositivas';
    //------------ importacion de plantillas para creacion de contenido ------
    // import ColC1 from './componentes/col1.vue';
    // import ColC2 from './componentes/col2.vue';
    // import ColC3 from './componentes/col3.vue';
    import pregPU from './componentes/pregPU.vue';
    import pregPM from './componentes/pregPM.vue';
    import pregPV from './componentes/pregPV.vue'; 



    export default {
        // componentes 
        components:{
            ComponenteClases,
            componenteListaDiapositiva,
            SelectorDiapositiva,
            // ColC1,
            // ColC2,
            // ColC3,
            pregPU,
            pregPM,
            pregPV,
            visorContenido,
            Confirm
            // Colprueba,
            // MiniaturasDiapositivas
            //Colwizard 
        },


        data(){
            return{
                mensaje : {tipo:null, mensaje: null, tiempo:null}, // mensaje de sistema
                ruta_api: API_URL,
            
                guardando:false,  
                confirmDeleteUnidad: false,
                unidadDelete: '',  

                listPais : '',
                listNivel: '',
                listGrado: '',
                listArea:  '',
                listCurso: '',

                vis_tema:[],
                api_mant_pais :[],
                api_mant_nivel:[],
                api_mant_area:[],
                api_mant_curso:[],
                api_mant_grado:[],


                listTemaPais:[],
                listTemaGrado:[],
                listTemaArea : [],
                listTemaCurso:[],
                api_contenido:[],
                prueba:[],
                lapregunta:[],
                api_contenidos:[],

                verCuadernoTrabajo: false,
                disabledNivel: true,
                disabledGrado:true,
                disabledArea:true,
                disabledCurso:true,

                disabledTemaPais:true,
                disabledTemaArea:true,
                disabledTemaCurso:true,
                disabledTemaGrado:true,


                search:'',


                paramsTemas:{
                    id_pais : '',
                    id_nivel:'',
                    id_grado:'',
                    id_area:'',
                    id_curso:'',
                    id_tema:''
                } ,


                headers_tema: [
                    { text: 'UNIDAD', value: 'nombre_tema', class:'secondary black--text'},
                    { text: 'ORDEN', value: 'orden', class:'secondary black--text'},
                    /*
                    { text: 'CUADERNO DE ACTIVIDADES', value:'cuaderno', align: 'center', class:'secondary black--text'},
                    */
                    { text: '', value: 'action_crear_clase', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'},
                    { text: 'EDITAR', value: 'action_editar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'},
                    { text: 'BORRAR', value: 'action_borrar', sortable: false , align: 'center', class:'secondary black--text px-0 mx-0', width:'1'}
                ],

                dialog:false,
                agregar:false,
                editar:false,
                editedIndex:-1,
                errorTema:false,
                menssageError:'',
                mensaje_cuaderno:false,
                modal_cuaderno:false,
                nombreArchivo:'',

                editedItem: {
                    id_us_ing: sessionStorage.id,
                    id_us_mod: null,
                    fec_us_mod: null,
                    estado_tema: 1,
                    nombre_tema: '',
                    id_nivel:0,
                    id_grado: null,
                    id_area: null,
                    id_curso: null,
                    flag_malla_curricular: 1,                    
                    id_usuario:sessionStorage.id,
                    orden:null,
                },

                defaultaddtema: {
                    id_us_ing:null,
                    id_us_mod: null,
                    fec_us_mod: '',
                    estado_tema: 1,
                    nombre_tema: '',
                    id_grado:null,
                    flag_malla_curricular: 1,
                    id_curso: null,
                    id_usuario:sessionStorage.id,
                    orden:null,
                },

                temas:true,
                ////////////////////
                componentClase:'',
                datosTema:{},
                arrayGeneral:{},
                arrayCuaderno:{},
                api_vistaclase:{
                    id_nivel:"",
                    id_grado:"",
                    id_area:"",
                    id_curso:"",
                    id_tema:""
                },

                micontenido:[],
                //////////////////
                api_list_contenidos:[],
                ////////////////
                parametroConfig:{},

                selectorColumna:false,
                componenteTipoDiapositiva:'',
            
            
                //validaciones de formulario
                rul: {
                    required: value => !!value || 'Campo Requerido',
                    inputReq: value => !!value || 'Campo Requerido',
                    selectReq: value => !!value || 'Debe seleccionar un campo de la lista',
                    email: value => /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/.test(value) || 'El correo Electrónico es incorrecto',
                    min4: v => (v || '').length >= 4 || 'Mínimo 4 caracteres',
                    min6: v => (v || '').length >= 6 || 'Mínimo 6 caracteres',
                    min8: v => (v || '').length >= 8 || 'Mínimo 8 caracteres',
                    max10: v => (v || '').length <= 10 || 'Máximo 10 caracteres',
                    max11: v => (v || '').length <= 11 || 'Máximo 11 caracteres',
                    max12: v => (v || '').length <= 12 || 'Máximo 12 caracteres',
                    max20: v => (v || '').length <= 20 || 'Máximo 20 caracteres',
                    max30: v => (v || '').length <= 30 || 'Máximo 30 caracteres',
                    max50: v => (v || '').length <= 50 || 'Máximo 50 caracteres',
                    max60: v => (v || '').length <= 60 || 'Máximo 60 caracteres',
                    max100: v => (v || '').length <= 100 || 'Máximo 100 caracteres',
                    max150: v => (v || '').length <= 150 || 'Máximo 150 caracteres',

                    email_null: value => {
                        if(value == '') {
                            return false
                        }
                        else{
                            const pattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.([a-zA-Z]{2,4})+$/
                            return pattern.test(value) || 'El correo Electrónico es incorrecto'
                        }
                    },
                },
            
            }
        },


        /// variables computadas 
        computed:{
            titleModalTema () {
                return this.editar !== true ? 'Crear Unidad' : 'Editar Unidad'
            },
        },


        mounted(){
            this.getAllTemas();
            this.getPais();
        },


        methods:{
            //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////

            //  ------- MENSAJE DE SISTEMA  --------
            ...mapMutations('mensajeSis', ['setEnviarMens']),
            ////////////////////////////////////////////////////////


            
            soloNumeros(event){
                var key = window.event ? event.which : event.keyCode;
                if (key < 48 || key > 57) {
                    event.preventDefault();
                }
            },


            /*********cargar temas segun seleccion de Nivel, grado, area , curso y tema */
            async getAllTemas(){
                //console.log(this.paramsTemas);
                this.vis_tema = []
                try{
                    await axios.post('manager/tema/temas/',this.paramsTemas)
                    .then(({data})=>{
                        this.vis_tema = data.payload;
                    })
                }
                catch(error){
                    console.log(error);
                }
            },


            //************************************************************ */ 
            /////////////// Cargar todos los Paises //////////////////////////
            async getPais(){
                try{
                    let response = await axios.get('/manager/pais/');
                    this.api_mant_pais = response.data
                }catch(error){
                    console.log(error);
                }
            }, 


            //************************************************************ */ 
            /////////////// Cargar todos los Niveles //////////////////////////
            async getNivel(){
                try{
                    let response = await axios.get('/manager/nivelCkOne/');
                    this.api_mant_nivel = response.data
                }catch(error){
                    console.log(error);
                }
            }, 



            ////////////////////////////////////////////////////////////////
            ///////////////// Cargar los niveles segun el pais seleccionado  ///////////////////////////
            async filtroPais(id){
                this.paramsTemas.id_pais  = id
                this.paramsTemas.id_nivel = ""
                this.paramsTemas.id_grado = ""
                this.paramsTemas.id_area  = ""
                this.paramsTemas.id_curso = ""

                //limpiamos los select
                this.api_mant_nivel = []
                this.api_mant_grado = []
                this.api_mant_area = []
                this.api_mant_curso = []
                try{

                    const response = await axios.get(`/manager/nivelCkOne/pais/${id}`)
                    this.api_mant_nivel = response.data
                    this.listArea = ''
                    this.listCurso = ''
                    this.getAllTemas();
                    if(this.api_mant_nivel.length>0){
                        this.disabledNivel = false
                        this.disabledArea = true
                    }
                }catch(error){
                    console.log(error);
                }
            },


            ////////////////////////////////////////////////////////////////
            ///////////////// Cargar los Grados  ///////////////////////////
            async filtroNivel(id){
                this.paramsTemas.id_nivel = id
                this.paramsTemas.id_grado = ""
                this.paramsTemas.id_area = ""
                this.paramsTemas.id_curso = ""

                this.api_mant_grado = []
                this.api_mant_area = []
                this.api_mant_curso = []
                try{
                    const response = await axios.get('/manager/gradoCkOne/grados/'+id+'');
                    this.api_mant_grado = response.data
                    this.listArea = ''
                    this.listCurso = ''
                    this.getAllTemas();
                    if(this.api_mant_grado.length>0){
                        this.disabledGrado = false
                        this.disabledArea = true
                        this.disabledCurso = true
                    }
                }catch(error){
                    console.log(error);
                }
            },
            ////////////////////////////////////////////////////////////////
            /////////////// seeccionar grados y habilitar cursos /////////
            /***********ejecutar temas por grados */
            async  filtroGrados(id){
                this.paramsTemas.id_area = ""
                this.paramsTemas.id_curso = ""
                this.paramsTemas.id_grado = id

                this.api_mant_area = []
                this.api_mant_curso = []

                this.listCurso = null
                this.listArea = null
                this.disabledCurso = true
                await  this.getArea(this.listNivel);
                await  this.getAllTemas();
                },
            //////////////////////////////////////////////////////////////
            ////////////  cargar areas  //////////////////////////////////
            async getArea(id){
                try{
                                
                    const response = await axios.get(`/manager/areaCkOne/nivel/${id}`)
                    this.api_mant_area = response.data 
                    if(this.api_mant_area.length>0){
                        this.disabledArea = false;
                    }else{
                        this.disabledArea = true
                      
                    }
                }catch(error){
                    console.log(error);
                }
            },
            ////////////////////////////////////////////////////////////
            ///////////////  cargar los cursos  ///////////////////////
            async filtroArea(id){
                    this.paramsTemas.id_curso = ""
                    this.paramsTemas.id_area = id
                    this.api_mant_curso = []

                    let params = {
                        id_area: id,
                        id_grado: this.paramsTemas.id_grado, 
                        id_pais: this.paramsTemas.id_pais
                    }
                    try{
                        const  response = await axios.post('/manager/cursoCkOne/cursos/',params);
                        this.api_mant_curso = response.data
                        if(this.api_mant_curso.length>0){
                            this.disabledCurso = false
                        }else{
                            this.disabledCurso = true
                            
                        }
                        this.getAllTemas();
                    }catch(e){
                    console.log(e);
                    }
            },
            //////////////////////////////////////////////////////////////
            /////////////////  CARGAR TEMAS SEGUN CURSO /////////////////
            async filtroCursos(id){
                this.paramsTemas.id_curso = id
                await this.getAllTemas()
            },
            /////////////////////////////////////////////////////////////
            ///////////  AGREGAR TEMA NUEVO   //////////////////////////
            aggTema(){
                    this.disabledTemaPais   = false
                this.dialog = true
                this.agregar = true
                this.editar = false
                this.resetValidation()
                this.listTemaPais = JSON.parse(JSON.stringify(this.api_mant_pais))

            
            },

            ///////////////////////////////////////////////////////////
            ////////////// TRAER GRADOS PARA CREAR TEMAS //////////////
            async  GetTemaNivelGrado(id){
                
                try{
                     this.paramsTemas.id_pais = id
                    const response = await axios.get(`manager/gradoCkOne/nivelGrado/pais/${id}`);
                    this.listTemaGrado = response.data
                    //console.log(this.listTemaGrado)
                    this.disabledTemaGrado = this.listTemaGrado.length > 0 ? false : true;
                }catch(e){
                    console.log(e)
                }
            },


            ////////////////////////////////////////////////////////////////////
            //////////////TRAER LOS AREAS X el nivel - grado seleccionado  /////
            async GetTemaArea(id){

                let datosFiltrado = this.listTemaGrado.filter(e => e.id == id) 
                this.editedItem.id_nivel = datosFiltrado[0].id_nivel
                console.log(`Nivel:${this.editedItem.id_nivel}, Grado : ${id}`)

                try{                   
                    const response    = await axios.get(`manager/areaCkOne/nivel/${this.editedItem.id_nivel}`)
                    this.listTemaArea = response.data
                    this.disabledTemaArea = this.listTemaArea.length > 0 ? false : true;
                    
                }catch(e){
                    console.log(e)
                }
            },

            ////////////////////////////////////////////////////////////
            //////////////TRAER LOS CURSOS PARA CREAR TEMA /////////////
            // eslint-disable-next-line no-unused-vars
            async  GetTemaCurso(id){
                // this.paramsTemas.id_area = id
                // let params = {id_pais:this.paramsTemas.id_pais, id_area :this.paramsTemas.id_area, id_grado :this.paramsTemas.id_grado}
                try{
                    const  response = await axios.post(`/manager/cursoCkOne/cursos/`,this.editedItem);
                    // const response = await axios.get(`/manager/cursoCkOne/cg/list/${id}`);
                    this.listTemaCurso = response.data
                    this.disabledTemaCurso = this.listTemaCurso.length > 0 ? false : true;
                }catch(error){
                    console.log(error);
                }
            },
            ////////////////////////////////////////////////////////////
            ////////////////   AGREGAR NUEVO TEMA  /////////////////////
            async  addTema(){
                if (this.$refs.formTema.validate()) {
                // this.paramsTemas.id_curso = this.editedItem.id_curso
                //this.agregar = false
                this.guardando = true
                // this.agregar = true
               
                //    let params = this.editedItem
                    try{
                        await axios.post(`/manager/tema/`,this.editedItem)
                        .then(({data})=>{
                            //console.log("data:",data)
                            if (data.messageT == this.$states.error) {
                                this.setEnviarMens({tipo:"E", mensaje: data.message, tiempo:null})
                                this.agregar = true
                            } else{
                                this.setEnviarMens({tipo:"S", mensaje: data.message, tiempo:null})
                                this.getAllTemas();
                                this.dialog = false
                                this.editedItem = Object.assign({}, this.defaultaddtema)
                                this.editedIndex === -1
                                //this.agregar = true
                            }
                            this.guardando = false
                        })
                    }
                    catch(error){
                        console.log(error);
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                        //this.agregar = true   
                        this.guardando = false                     
                    }
                }
            },

            /////////////////////////////////////////////////////////////////////
            /////////////////  habilitar modal y datos al formulario ////////////
            editTema(item){

                // console.log("IMTES:"+item)
                // console.log(item)
                this.listTemaPais = JSON.parse(JSON.stringify(this.api_mant_pais))
                this.editedIndex = this.vis_tema.indexOf(item)
                this.editedItem = Object.assign({}, item)
                
                this.disabledTemaPais   = true
                this.disabledTemaGrado  = true
                this.disabledTemaArea   = true
                this.disabledTemaCurso  = true
                this.editar  = true
                this.agregar = false
                this.dialog = true
                this.resetValidation()

                // this.GetTemaNivelGrado(item.id_pais)
                this.loadQueryEdit(item);
                    
            },
        


            
            /////////////////////////////////////////////////////////////////////
            //////////////////  traer los registros para editar  ////////////////
            async loadQueryEdit(params){
                try{

                    // console.log(params)    
                    // console.log("paramtros Para Editar:"+params.id)
                    const response01 = await axios.get(`manager/gradoCkOne/nivelGrado/pais/${params.id_pais}`)
                    this.listTemaGrado = response01.data
                    console.log(response01.data)
                                

                    const response02    = await axios.get(`manager/areaCkOne/nivel/${params.id_nivel}`)
                    this.listTemaArea = response02.data

                    const  response03 = await axios.post(`/manager/cursoCkOne/cursos/`,params)
                    this.listTemaCurso = response03.data

                   
                }catch(error){
                    console.log(error)
                }
            },
            

            
            
            /////////////////////////////////////////////////////////////////
            // actualizar  el tema
            async updateTema(id){
                this.paramsTemas.id_grado = this.editedItem.id_grado
                this.paramsTemas.id_curso = this.editedItem.id_curso
                this.paramsTemas.id_nivel = this.editedItem.id_nivel
                this.guardando = true
                try{
                    await axios.put(`/manager/tema/${id}`,this.editedItem)
                    .then(({data})=>{
                        if (data.messageT == this.$states.error){
                            this.setEnviarMens({tipo:"E", mensaje: data.message, tiempo:null})
                        } else {
                            this.setEnviarMens({tipo:"S", mensaje: data.message, tiempo:null})
                            this.getAllTemas()
                            this.closeModalTema();
                            //console.log(response)
                        }
                        this.guardando = false
                    })
                    
                }
                catch(error){
                    this.guardando = false
                    console.log(error);
                }
            },
            ////////////////// cuaderno de trabajo /////////////////////
                addCuaderno(item){
                    console.log(item)
                    this.modal_cuaderno         = true
                    this.mensaje_cuaderno       = false
                    this.arrayCuaderno.id_nivel = item.id_nivel
                    this.arrayCuaderno.id_grado = item.id_grado
                    this.arrayCuaderno.id_curso = item.id_curso
                    this.arrayCuaderno.id_tema  = item.id
                    this.arrayCuaderno.id_area  = item.id_area
                  
                },
  
            //////////////////////////////////////////////////////////////////
            //////////////  guardar cuaderno en directorio //////////////////
            async submitFileCuaderno(){

                    let formData = new FormData();
                    formData.append('subirArchivo',  this.nombreArchivo);
                    formData.append('id_nivel',        this.arrayCuaderno.id_nivel);
                    formData.append('id_grado',      this.arrayCuaderno.id_grado);
                    formData.append('id_curso',      this.arrayCuaderno.id_curso);
                    formData.append('id_tema',      this.arrayCuaderno.id_tema);
                    formData.append('id_area',      this.arrayCuaderno.id_area);
                    
                try{
                    let response = await  axios.post('/archivo/cuadernoTrabCK1Add',
                        formData,
                        {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                        )
                this.addCuadernoTrabajo(response.data);
                this.$refs.myFileInput.value = '';
                //this.mensaje_sesion = true
                console.log(response.data)
                }catch(error){
                    console.log(error)
                }
            },
            closeCuaderno(){
                    this.modal_cuaderno = false
                    this.mensaje_cuaderno = false
                    this.arrayCuaderno = {}
                },
            cargarPrevia(e) {
                var files = e.target.files || e.dataTransfer.files;
                    if (!files.length)
                    return;
                    this.nombreArchivo =  files[0]
                    console.log(this.nombreArchivo)
            },
            ///////////////////////////////////////////////////////////////////////
            /////////////funcion para agregar cuaderno de trabajo a BD/////////////
            async addCuadernoTrabajo(response){
                console.log(response);
                var id = this.arrayCuaderno.id_tema
                let paramCuaderno = {
                    id_usuario:sessionStorage.id,
                    cuaderno_trabajo:`${response.uri}${response.nombreArchivo}`
                }
                try{
                    await axios.put(`/manager/tema/ct/${id}`,paramCuaderno);
                    this.mensaje_cuaderno = true
                    this.getAllTemas();
                    setTimeout(() => {
                        this.closeCuaderno();
                    }, 1000)
                }catch(error){
                    console.log(error)
                }
            },
            ///////////////////////////////////////////////////////////////
            async deleteCuaderno(item){
                console.log(item);
                var id = item.id
                let paramCuaderno = {
                    id_usuario:sessionStorage.id,
                    cuaderno_trabajo:null
                }
                try{
                    let res = await axios.put(`/manager/tema/ct/${id}`,paramCuaderno);
                    this.mensaje_cuaderno = true
                    console.log(res);
                    if(res.data.messageT === 'S'){
                        await this.deleteArchivoCuaderno(item);
                    }    
                }catch(error){
                    console.log(error)
                }
            },
            async  deleteArchivoCuaderno(item){
                    let params =  {
                        "ruta":item.cuaderno_trabajo
                    }
                    console.log(params);
                    try{   
                    let cf =  confirm('¿Está seguro de borrar este registro?')
                    if (cf) {
                            let response = await axios.post("/archivo/delete/",params);
                        this.setEnviarMens({tipo:response.data.messageT, mensaje: response.data.message, tiempo:null})
                        this.getAllTemas();
                    } 
                    }catch(error){
                        this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                    }
            },
            //////////////////  Eliminar Tema  ////////////////////////////
            showConfirmDeleteUnidad(item) {
                this.unidadDelete = item.id
                this.confirmDeleteUnidad = true
            },
            cerrarConfirmDeleteUnidad(){
                this.confirmDeleteUnidad = false
            },
            async  deleteTema(){
                try{
                    const {data} = await axios.put(`/manager/tema/dt/inac/${this.unidadDelete}`)
                    this.getAllTemas();
                    this.setEnviarMens({tipo:data.messageT, mensaje: data.message, tiempo:null})
                    this.unidadDelete = ''
                    this.cerrarConfirmDeleteUnidad()                
                } catch(error){
                    this.setEnviarMens({tipo:"E", mensaje: `${error}`, tiempo:null})
                }
            },
            ///////////////////   MOSTRAR MENSAJE DE ERROR  ////////////////
            mostrarError(mensaje){
                this.errorTema = true
                this.menssageError = mensaje
                setTimeout( () => {
                    this.errorTema = false
                },3000)
            },
            ////////////////////////////////////////////////////////
            /////////////// CERRAR MODAL PARA CREAR TEMAS /////////////
            closeModalTema(){
                    this.agregar = true
                    this.editar = false
                    this.dialog = false
                    this.editedItem = Object.assign({}, this.defaultaddtema)
                    this.editedIndex === -1
                    this.disabledTemaCurso = true
            },
            ////////////////////////////////////////////////////////////
            /////////////////////////////////////////////////////////////////////////////////
            async vistaClase(item){
                // console.log('itemmms'+JSON.stringify(item));
         
                try{
                    this.api_vistaclase.id_tema = item.id
                        const  {data} = await axios.post("/manager/clase/lista/",this.api_vistaclase)
                        this.micontenido = data.payload
                        this.datosTema.id_tema = item.id
                        this.datosTema.nombreTema = item.nombre_tema
                        this.datosTema.grado = item.desc_grado
                        this.datosTema.curso = item.desc_curso
                        this.datosTema.nivel = item.desc_nivel
                        this.datosTema.area = item.desc_area
                        /**********/
                        this.arrayGeneral.id_adm_nivel = item.id_nivel
                        this.arrayGeneral.id_adm_area = item.id_area
                        this.arrayGeneral.id_grado = item.id_grado
                        this.arrayGeneral.id_curso = item.id_curso
                        this.arrayGeneral.id_tema = item.id
                        this.injectarComponente();
                    }
                    catch(error){
                    console.log(error);
                    }
            },
            //////////////////////////////////////
            // funciones para habilitar inyeccion de componente 
            injectarComponente(){
                this.componentClase =  'ComponenteClases' 
                this.temas = false
            },
            regresar(){
                this.componentClase = ''
                this.temas = true
                this.micontenido = []
                this.arrayGeneral = {}
            },
            /*********actualizar clases despues de agregar una clase a un tema */
            async  actualizarClase(id){
                //console.log('actualizando,....');                
                this.micontenido=[]
                this.api_vistaclase.id_tema = id
                try{
                    const {data} = await axios.post("/manager/clase/lista/",this.api_vistaclase);
                    //console.log("id:",id,"data:",response)
                    this.micontenido = data.payload;
                }
                catch(error){
                    console.log(error);
                }
            },
            ///////////////////////////////////////////////////////////////////
            mostrarMensaje(tipo,mensaje){
                this.setEnviarMens({tipo:tipo, mensaje:mensaje, tiempo:null})
            },
            ////////////////// funcion para listar los contenidos ////////////
            async  getAllContenidos(item){
                //console.log(JSON.stringify(item))
                var id = item.id_clase
                try{
                    let {data} = await axios.get(`/manager/contenido/list/${id}`)
                    
                    this.api_list_contenidos = data.payload;
                    this.arrayGeneral.num_diapositiva = this.api_list_contenidos.length+1
                    this.componentClase =  'componenteListaDiapositiva' 
                    this.arrayGeneral.id_clase = item.id_clase
                    this.arrayGeneral.nombre_clase = item.nombre_clase
                    console.log('los links====000==>>>'+JSON.stringify(this.api_list_contenidos))
                }
                catch(error){
                console.log(error);
                }
            },
            ////////////////////////////////////////////////////////////////////
            volverClasesLista(){
                this.componentClase =  'ComponenteClases' 
                this.api_list_contenidos = []
            },
            //////////////////////////////////////////////////////////////
            abrirSelector(){
                    this.selectorColumna = true
                    this.componentClase = ''
            },
            volverTemplate(){
                this.componentClase =  'componenteListaDiapositiva' 
                this.selectorColumna = false
                this.componenteTipoDiapositiva = ''
            },
            volverSeleccion(){
                this.selectorColumna = true
                this.componenteTipoDiapositiva = ''
            },
            volverEditar(){
                this.componentClase =  'componenteListaDiapositiva' 
                this.componenteTipoDiapositiva = ''
                this.SelectorDiapositiva = false
            },
            validarColumna(col){

                    this.parametroConfig = {evento: 'agregar'}
                    this.componenteTipoDiapositiva = col
                    this.selectorColumna = false
                    var numOrden = this.api_list_contenidos.length+1;
                    this.arrayGeneral.orden = numOrden
            },



            ///////////////////////////////////////////////////////////
            //------------------- Contenidos Al guardar 
            async actulizarData2(id){
                try{
                    const {data} = await axios.get(`/manager/contenido/list/${id}`)
                    this.api_list_contenidos = data.payload;
                    this.arrayGeneral.num_diapositiva = this.api_list_contenidos.length+1
                    }catch(error){
                    console.log(error);
                }
            },


            ///////////////////////////////////////////////////////////
            //-------------------actualizar listas despues del creador 
            async actualizarDiapositivaCreador(id){
                try{
                    const {data} = await axios.get(`/manager/contenido/list/${id}`)
                    this.api_list_contenidos = data.payload;
                    this.arrayGeneral.num_diapositiva = this.api_list_contenidos.length+1
                    this.selectorColumna = true
                    this.componenteTipoDiapositiva = ''
                }catch(error){
                    console.log(error);
                }
            },
            /////////////////////////////////////////////////////////////
            //-------------------traer contenido para editar --------------------------
        

            async  editarContenido(item){

                this.arrayGeneral.id_contenido = item.id                        
                this.parametroConfig = {evento:"editar", item}
                this.componentClase = 'col'+item.tipo
                // console.log(' editando ====>>>'+JSON.stringify(item));
                // console.log(' editando ====>>>'+JSON.stringify(this.arrayGeneral));   
            },


            ///////////////////////////////////////////////////////////////
            /*******consulta para traer datos de la pregunta y habilitar edicion */
            async editarPregunta(item){             
                
                var id = item.id
                try{
                    let {data} = await axios.get(`/manager/contenido/preg/${id}`);
                    
                    // this.lapregunta = response.data[0]; 
                    this.parametroConfig = {evento: 'editar', item : data.payload[0] }
                    //console.log('editando====>>>'+JSON.stringify(this.lapregunta));
                    this.arrayGeneral.id_contenido = id
                    this.componentClase = 'preg'+item.tipo
                }catch(error){
                    console.log(error);
                }  
            },
            //////////////////////////////////////////////////////////////////
            /// funcion de actualizacion de contenido despues de crear una diapositiva nueva, funcion llamada por emit desde el template
            async actualizarListaContenidos(id_clase){
                try{

                    let{data} = await axios.get(`/manager/contenido/list/${id_clase}`)                    
                    
                    this.api_list_contenidos = data.payload;
                    this.arrayGeneral.num_diapositiva = this.api_list_contenidos.length+1
                    this.componentClase =  'componenteListaDiapositiva' 

                }catch(error){
                    console.log(error);
                }
            },
    
                // Validar resetear campos al guardar
            resetValidation() {
                this.$refs.formTema.resetValidation()
            },
        }
    }
</script>

<style scoped>
    .poup{
        position: absolute;
        background: #FFDD33;
        width: 220px;
        height: 30px;
        padding: 3px;
        font-size: 15px;
        text-align: center;
        border-radius: 5px;
        box-shadow: 0px 0px 4px 3px #DBDBDA;
    }

    .text-modal{
        color: #fff;
        text-transform: uppercase;
    }

    .template-button{
        position: relative;
        display: inline-block;
        padding:4px ;
    }


    .miniaturas{
        display: block;
    }


    @media(max-width:425px){
        .miniaturas{
            display: none;
        }
    }
</style>